module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box text-center"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-xs-12 text-left"
  }, [_c('button', {
    staticClass: "btn btn-default m-y-10 inline-block",
    on: {
      "click": _vm.clearCId
    }
  }, [_vm._v("\n                新增門市群組\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger pull-right m-y-10 ",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    },
    on: {
      "click": _vm.delModalOpen
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-2 bg-light-gray select-element-block text-left"
  }, _vm._l((_vm.storeClassList), function(storeClass, index) {
    return _c('div', {
      staticClass: "select-element",
      class: {
        'active': _vm.curId === storeClass.id
      },
      on: {
        "click": function($event) {
          return _vm.clickOption(storeClass)
        }
      }
    }, [_c('span', {
      staticClass: "text-w-600"
    }, [_vm._v(_vm._s(storeClass.name))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-10"
  }, [_c('div', {
    staticClass: "box-body",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "row m-b-15"
  }, [_c('div', {
    staticClass: "row center-block text-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.name),
      expression: "info.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.info.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('h5', [_vm._v("選擇門市")]), _vm._v(" "), _c('muti-select-two', {
    attrs: {
      "setting": _vm.addStoresSetting,
      "reNew": _vm.reNew,
      "reSet": _vm.reSet
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n                    取消\n                  ")]), _vm._v(" "), (!_vm.curId) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkStoreClass(1)
      }
    }
  }, [_vm._v("\n                    新增\n                  ")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkStoreClass(2)
      }
    }
  }, [_vm._v("\n                    編輯\n                  ")])])])])])])])])]), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("門市群組名稱")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5dea52d9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/CrStoreClass.vue
// module id = 2445
// module chunks = 1